import { render, staticRenderFns } from "./remove-agent-from-case-request.vue?vue&type=template&id=6fe01012&scoped=true&"
import script from "./remove-agent-from-case-request.vue?vue&type=script&lang=js&"
export * from "./remove-agent-from-case-request.vue?vue&type=script&lang=js&"
import style0 from "./remove-agent-from-case-request.vue?vue&type=style&index=0&id=6fe01012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe01012",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
